import { JdInfiniteScroll } from '@jdesign-vue/components/infinite-scroll'
import { JdLoading } from '@jdesign-vue/components/loading'
import { JdMessage } from '@jdesign-vue/components/message'
import { JdMessageBox } from '@jdesign-vue/components/message-box'
import { JdNotification } from '@jdesign-vue/components/notification'
import { JdPopoverDirective } from '@jdesign-vue/components/popover'

import type { Plugin } from 'vue'

export default [
  JdInfiniteScroll,
  JdLoading,
  JdMessage,
  JdMessageBox,
  JdNotification,
  JdPopoverDirective,
] as Plugin[]
